<template>
  <div class="bg-white px-4 py-5 sm:p-4">
    <div class="text-xl font-bold" style="text-align: center;">
      Observaciones Embargo Persona N° : <b style="color: #0e9f6e;">{{ data.numero_proceso }}</b>
    </div>
  </div>

  <div class="bg-white px-3 py-4 sm:p-4">
    <div class="flex flex-wrap justify-center sm:justify-between w-full gap-3 sm:gap-0 py-5 items-center">
      <button v-if="viewInterna == 'list'" type="button" @click="changeView('update')"
        class="flex items-center w-full rounded-md sm:w-1/3 lg:w-1/6 border border-transparent bg-indigo-600 py-2 px-3 text-sm font-medium  text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        style="white-space: nowrap;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-6 h-6 mr-1">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        Nueva Observación
      </button>

      <button @click="viewInterna == 'list' ? handleButtonClick() : changeView('list');"
        class="px-4 py-2 text-white bg-green-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-green-600 focus:outline-none">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="inline-block w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
        </svg>
        <span class="ml-3">Volver</span>
      </button>
    </div>
    <slot></slot>
  </div>

  <div class="mt-6 overflow-x-auto" v-if="viewInterna == 'list'">
    <table class="w-full table-auto">
      <thead>
        <tr class="text-sm font-semibold text-center border-b-2 border-blue-500 uppercase">
          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            NÚMERO OFICIO
          </th>
          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            FECHA
          </th>
          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            OBSERVACIÓN
          </th>
          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            SOPORTE OBSERVACIÓN
          </th>
          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            OPCIONES
          </th>
        </tr>
      </thead>
      <tbody class="text-sm font-normal text-gray-700 text-center">
        <tr class="py-10 bg-gray-100 hover:bg-gray-200 font-medium"
          v-for="(dataObservacion, indexCollectionData) of collectionData" :key="indexCollectionData">
          <td class="px-4 py-4">
            {{ dataObservacion.numero_oficio }}
          </td>
          <td class="px-4 py-4">
            {{ dateTime(dataObservacion.fecha) }}
          </td>
          <td class="px-4 py-4">
            {{ dataObservacion.observacion }}
          </td>
          <td class="px-4 py-4">
            <button v-if="dataObservacion.url_soporte_observacion"
              @click="descargarDocumentoSoporte(dataObservacion.url_soporte_observacion)"
              class="px-4 py-2 text-white bg-blue-500 w-full rounded-md hover:bg-blue-600 focus:outline-none">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="inline-block w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
              </svg>
              <span class="ml-3">Descargar Soporte de Observación</span>
            </button>
          </td>
          <td class="px-4 py-4">
            <button v-if="!dataObservacion.estado" @click="enableDisableState(dataObservacion, 'activar')"
              class="items-center px-2 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.5 12.75l6 6 9-13.5" />
              </svg>
            </button>
            <button v-else @click="enableDisableState(dataObservacion, 'desactivar')"
              class="items-center px-2 py-2 text-white bg-red-500 rounded-md hover:bg-red-600 focus:outline-none">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div v-if="viewInterna == 'update'">
    <div class="bg-white px-4 py-5 sm:p-6">
      <div class="grid grid-cols-6 gap-6">
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="numero_oficio" class="block text-sm font-medium text-gray-700">Número Oficio <span
              style="color: red">(*)</span></label>
          <input type="text" id="numero_oficio" v-model="numero_oficio" :disabled="numero_oficio"
            style="background-color: #e7e7e7"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="fecha" class="block text-sm font-medium text-gray-700">Fecha <span
              style="color: red">(*)</span></label>
          <input type="date" id="fecha" v-model="fecha"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="observacion" class="block text-sm font-medium text-gray-700">Observación <span
              style="color: red">(*)</span></label>
          <textarea type="text" id="observacion" v-model="observacion"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"></textarea>
        </div>

      </div>
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label class="block text-sm mb-1 font-medium text-gray-700">Cargue de soporte</label>
        <div class="max-w-xl mb-3" id="cargue_archivo_embargos">
          <label style="min-height: 8rem;" for="archivo"
            class="flex justify-center w-full transition bg-white border-2 border-gray-300 border-dashed rounded-md appearance-none cursor-pointer hover:border-gray-400 focus:outline-none">
            <span ref="fileFormEnter" id="contenedor_archivo" class="flex items-center space-x-2 w-full">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-gray-600 grow" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
              </svg>
              <span class="font-medium text-gray-600 grow">
                Arrastra el archivo aquí, o
                <span class="text-blue-600 underline">abre el explorador</span>
              </span>
            </span>
            <span ref="fileFormDrop" id="drag_over" class="hidden">
              <svg xmlns="http://www.w3.org/2000/svg" class="self-center w-6 h-6 inline-block text-gray-600 grow"
                fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
              </svg>
            </span>
            <span ref="fileFormUploaded" id="info_archivo"
              :class="documentoSoporte ? 'font-bold block w-full flex flex-col justify-center align-middle gap-3 px-3' : 'hidden'">
              <img id="preview_archivo" src="" alt="" />
              <span class="flex justify-center align-middle gap-3">
                <svg xmlns="http://www.w3.org/2000/svg" class="self-center w-6 h-6 inline-block text-gray-600"
                  fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                </svg>
                <span id="nombre_archivo" class="self-center"></span>
              </span>
            </span>
            <input type="file" id="archivo" class="hidden" @change="
              uploadFile(document.getElementById('archivo').files.item(0));
            documentoSoporte = document.getElementById('archivo').files.item(0);">
          </label>
        </div>
      </div>
    </div>

    <div id="btnUpdate" class="bg-gray-50 px-4 py-3 text-right sm:px-6">
      <button type="button" @click="customSaveData()"
        class="w-full rounded-md sm:w-1/3 lg:w-1/6 border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium  text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
        Guardar
      </button>
    </div>
  </div>
</template>

<script>
import { saveUpdateData } from "@/layouts/main";
import { ref } from "vue";
import moment from 'moment';
import Swal from "sweetalert2";
import { uploadFile, useAPIRest, removeFile, swal, generateTextError, verifyHttpCode } from "@/common/constants";
import mime from "mime";
import { enableDisableData } from "@/layouts/main";
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'ObservacionesEmbargoPersonaComponent',
  props: ['data', 'entity', 'authToken'],
  emits: ["updateValues", "watchList"],
  async setup(props, { emit }) {

    const viewInterna = ref('list');
    const numero_oficio = ref(props.data.numero_oficio ?? '');
    const fecha = ref('');
    const observacion = ref('');
    const documentoSoporte = ref(null);

    const collectionData = ref([]);

    const changeView = (tipo_vista) => {
      viewInterna.value = tipo_vista
    }

    const customSaveData = async () => {
      try {

        let dataSave = {
          id_embargo_persona: parseInt(props.data.id),
          numero_oficio: numero_oficio.value,
          fecha: fecha.value,
          observacion: observacion.value,
          url_soporte_observacion: documentoSoporte.value,
        }

        const nameCompletoFields = {
          numero_oficio: 'numero oficio',
          fecha: 'fecha',
          observacion: 'observacion',
        }

        let error = '';
        for (let key in nameCompletoFields) {
          if (dataSave[key] == '') {
            error += `El campo ${nameCompletoFields[key]} es obligatorio. <br>`;
          }
        }

        if (error != '') {
          Swal.fire({
            title: error,
            icon: 'error',
            showCloseButton: true,
            focusConfirm: false,
          })
          return;
        }

        let listApi = {
          create: process.env.VUE_APP_NEST_EMBARGOPERSONA_CREATE_OBSERVACION,
          list: process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDONE_OBSERVACION,
        };

        /**
         Valida el tamaño del archivo de soporte y lo agrega al FormData si es válido.
        */
        const newLoadData = new FormData();
        let validDocumentoSoporte = false;

        if (documentoSoporte.value) {
          const pesoMaximo = 10 * 1024 * 1024;
          if (documentoSoporte.value.size > pesoMaximo) {
            validDocumentoSoporte = false;
            removeFile(document.getElementById('cargue_archivo_embargos'));
            documentoSoporte.value = undefined;
            await swal.fire('¡El archivo excede el tamaño de 10MB maximo permitido!', '', 'error');
            return;
          } else {
            validDocumentoSoporte = true;
            const uniqueFilename = `${uuidv4()}-${documentoSoporte.value.name}`;
            newLoadData.append('file', documentoSoporte.value, uniqueFilename);
          }
        }

        await saveUpdateData({
          listApi,
          authToken: props.authToken,
          loadData: dataSave,
          action: 'crear',
          entity: props.entity,
          view: 'crear',
        }, undefined, false, false, true).then(async (resp) => {

          if (resp.id) {
            listApi = {
              create: process.env.VUE_APP_NEST_EMBARGOPERSONA_UPLOAD_SOPORTE_OBSERVACION,
            };

            newLoadData.append('id', resp.id);

            if (validDocumentoSoporte) {
              await saveUpdateData({
                listApi,
                authToken: props.authToken,
                loadData: newLoadData,
                action: 'crear',
                entity: props.entity,
                view: 'crear',
                options: {
                  save: {
                    contentType: 'auto'
                  },
                  update: {
                    contentType: 'auto'
                  }
                }
              }, emit, true, false, true);
            }
          }
        });

        observacion.value = '';
        removeFile(document.getElementById('cargue_archivo_embargos'));
        documentoSoporte.value = undefined;
        viewInterna.value = 'list';
        fecha.value = '';

        listData();

      } catch (error) {
        Swal.fire({
          title: 'Error al guardar',
          icon: 'error',
          showCloseButton: true,
          focusConfirm: false,
        })
        console.error('Error al guardar:', error);
      }
    }

    const listData = async () => await useAPIRest(process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDALL_OBSERVACION, 'GET', props.authToken, undefined, undefined, 'application/json')
      .then(res => {
        collectionData.value = res.data;
      });

    listData();

    const handleButtonClick = () => {
      emit('updateValues', { view: 'listar' });
      emit('watchList', { parametro: 'numero_oficio' });
    }

    const enableDisableState = async (data, tipo) => {

      const listApi = {
        updateState: process.env.VUE_APP_NEST_EMBARGOPERSONA_UPDATESTATE_OBSERVACION
      };
      await enableDisableData(props.entity, tipo, data, listApi['updateState'], props.authToken)

      listData();
    }

    return {
      changeView,
      viewInterna,
      numero_oficio,
      customSaveData,
      collectionData,
      listData,
      handleButtonClick,
      documentoSoporte,
      document: document,
      uploadFile: uploadFile,
      enableDisableState,
      observacion,
      fecha
    }
  },
  methods: {
    dateTime(value) {
      return moment(value).format('DD/MM/YYYY');
    },
    async descargarDocumentoSoporte(fileName) {
      await useAPIRest(process.env.VUE_APP_NEST_EMBARGOPERSONA_OBTENERARCHIVO, 'GET', this.authToken, undefined, {
        'url': fileName
      }).then(async resJSON => {
        const { statusCode } = resJSON;
        delete resJSON.statusCode;
        const textoError = generateTextError(resJSON);
        if (verifyHttpCode(statusCode, 'success')) {
          const blob = await resJSON.blob();
          const newBlob = new Blob([blob], { type: mime.getType(fileName) });
          const url = window.URL.createObjectURL(newBlob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName.replace('src/assets/documentos_soporte_observacion_embargos_personas/', ''));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else await swal.fire(textoError, '', 'error');
      });
    },
  },
  watch: {
    "documentoSoporte": function (documentoSoporte) {
      if (documentoSoporte) {
        if (window.navigator.userAgent.includes("Firefox")) {
          const name = documentoSoporte.name;
          const mimeType = documentoSoporte.type;
          const lastDot = name.lastIndexOf('.');
          const fileName = name.substring(0, lastDot);
          const ext = name.substring(lastDot + 1);
          if (ext === 'csv' && mimeType !== 'text/csv') this.documentoSoporte = new File([documentoSoporte], `${fileName}.${ext}`, { type: 'text/csv' });
        }
      }
    },
  },
}

</script>